export const OIL_AND_GAS_AREA_PROPERTY_NAME = 'Oil and gas area';
export const OIL_AND_GAS_AREA_LEGACY_UNIT = '10³ m²';
export const OIL_AND_GAS_AREA_UNIT = 'km2';
export const THOUSAND_SQM_PER_KM2 = 1000;

const LEGACY_AREA_UNITS = new Set([
  OIL_AND_GAS_AREA_LEGACY_UNIT,
  '10^3 m2',
  '1000 m2',
  'thousand m2',
]);

export function isLegacyOilAndGasAreaUnit(unit?: string | null): boolean {
  const normalized = (unit ?? '').trim();
  if (!normalized) return false;
  return LEGACY_AREA_UNITS.has(normalized);
}

/** Convert stored Oil and gas area property value to km2 for calculations and display. */
export function oilAndGasAreaToKm2(value: number, unit?: string | null): number {
  if (isLegacyOilAndGasAreaUnit(unit)) {
    return value / THOUSAND_SQM_PER_KM2;
  }
  return value;
}

export function getOilAndGasAreaKm2FromProperties(
  properties: Array<{
    attribute_name: string;
    float_value?: number | null;
    integer_value?: number | null;
    attribute_unit?: string | null;
  }>,
): number | null {
  const prop = properties.find((p) => p.attribute_name === OIL_AND_GAS_AREA_PROPERTY_NAME);
  if (!prop) return null;
  const raw = prop.float_value ?? prop.integer_value ?? null;
  if (raw == null) return null;
  return oilAndGasAreaToKm2(Number(raw), prop.attribute_unit);
}
